import { render } from "./List.pug?vue&type=template&id=3147c067&ts=true&lang=pug&external"
import script from "./List.ts?vue&type=script&lang=ts&external"
export * from "./List.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/plugins/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3147c067"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3147c067', __exports__)) {
    api.reload('3147c067', __exports__)
  }
  
  module.hot.accept("./List.pug?vue&type=template&id=3147c067&ts=true&lang=pug&external", () => {
    api.rerender('3147c067', render)
  })

}


export default __exports__